/* eslint-disable no-console */
import React, { Fragment } from "react";
import Select, { components } from "react-select";
import _ from "lodash";

export default class PseudoAsyncSelect extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            maxReached      : false,
            selectedOptions : [],
            inputValue      : "",
            asyncOptions    : [],
            loading         : false,
            error           : false
        };
    }

    async componentWillMount() {
        if (this.props.asyncOptions) {
            if (typeof this.props.asyncOptions === "function") {
                this.setState({
                    loading : true
                });
                const asyncOptions = await this.props.asyncOptions();
                this.setState({
                    asyncOptions,
                    loading : false
                });
            } else if (typeof this.props.asyncOptions === "object") {
                this.setState({
                    asyncOptions : this.props.asyncOptions
                });
            } else {
                throw Error(
                    "Invalid asyncOptions property passed. (Requires Promise or Array object)"
                );
            }
        }
    }

    onChange(selectedOptions, { action }) {
        if (action === "select-option" && this.state.maxReached) {
            return;
        }

        selectedOptions = selectedOptions || [];
        const maxSelectedOptions = this.props.maxSelectedOptions || 5;

        if (
            action === "select-option" &&
            selectedOptions.length === maxSelectedOptions
        ) {
            this.setState({ maxReached : true });
        }

        // business as usual
        const maxReached = selectedOptions.length >= maxSelectedOptions;
        this.setState({ maxReached, selectedOptions }, () => {
            if (
                this.props.onOptionChange &&
                typeof this.props.onOptionChange === "function"
            ) {
                this.props.onOptionChange(selectedOptions);
            }
        });
    }

    noOptionsMessage({ inputValue }) {
        const { maxReached, loading, error } = this.state;
        if (loading) {
            return `Loading...`;
        }
        if (error) {
            return `Error Loading Options`;
        }
        const maxSelectedOptions = this.props.maxSelectedOptions || 5;
        return maxReached
            ? `You can only select ${maxSelectedOptions} option(s)...`
            : `No options matching "${inputValue}"`;
    }

    render() {
        const { maxReached, selectedOptions } = this.state;

        const Menu = props => {
            const optionsLength = _.keys(this.state.asyncOptions).length;
            return (
                <Fragment>
                    <components.Menu {...props}>
                        {props.children}
                        {!maxReached && !this.state.loading ? (
                            <div style={{ padding : "8px 12px" }}>
                                {`...
              ${optionsLength -
                                _.keys(this.state.selectedOptions).length -
                                _.keys(props.options).length}
              more options`}
                            </div>
                        ) : null}
                    </components.Menu>
                </Fragment>
            );
        };

        return (
            <Select
                onChange={this.onChange.bind(this)}
                onInputChange={inputValue => {
                    if (this.props.onInputChange) {
                        this.props.onInputChange(inputValue);
                    }
                    this.setState({ inputValue });
                }}
                options={
                    maxReached
                        ? selectedOptions
                        : _.filter(this.state.asyncOptions, o => {
                            return _.startsWith(
                                _.toLower(o.label),
                                _.toLower(this.state.inputValue)
                            );
                        })
                            .slice(0, this.props.maxViewedOptions || 5)
                }
                isMulti
                noOptionsMessage={this.noOptionsMessage.bind(this)}
                value={selectedOptions}
                components={{ Menu }}
                {...this.props}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/PseudoAsyncSelect.js